// extracted by mini-css-extract-plugin
module.exports = {"menuList_wrapper":"MenuList_menuList_wrapper__1txj5","title":"MenuList_title__3Y4sj","menuList_container":"MenuList_menuList_container__1mW52"};